import logo from './logo-footer.svg';
import { OndeckOsano} from '@odmonorepo/core-components';

export function CheckoutFooter() {
  return (
    <footer>
      <div className="container" style={{ maxWidth: '1400px' }}>
        <div id="submenu-footer">
          <div>
            <div className='d-flex justify-content-between align-items-center'>
            <div
              style={{
                display: 'inline-block',
                width: '150px',
                height: '35px',
              }}
            >
              <a href="https://ondeck.com/">
                <img src={logo} alt="" />
                <span className="visually-hidden">OnDeck</span>
              </a>
              </div>
              <div className='text-end'>
                <div>(888) 556-3483</div>
                <div>9 a.m. - 7:30 p.m ET</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ul className="nav fs-8 py-md-5 d-block d-md-flex">
            <li className="nav-item py-4 py-md-0">
              <a href="https://ondeck.com/privacy">Privacy Policy</a>
            </li>
            <li className="nav-item px-md-4">
              <a href="https://ondeck.com/security-policy">Security Policy</a>
            </li>
            <OndeckOsano className="py-4 py-md-0 d-block d-md-inline fw-bold" />
          </ul>
        </div>
        <div id="footer-disclaimers" className="pt-0 ps-3">
          <div>
            <ul>
              <li className="small" data-symbol="†">
                Same-Day Funding is only available Monday – Friday before 10:30 a.m. ET. If checkout is done before 10:30 a.m. ET, funds will typically be available by 5 p.m. local time the same day. If checkout is done after 10:30 a.m. ET, or on a weekend or bank holiday, it will not qualify for Same-Day Funding and funds will be deposited within 2 – 3 business days.
              </li>
              <li className="small" data-symbol="*">
                Registration terms and conditions apply. Occasionally, the
                transfer may take up to 30 minutes to complete due to potential
                Visa & bank processing lags. This benefit is available at no
                additional cost with a vast majority of major banks
                participating. Instant Funding is available for transactions
                between $1K – $10K.
              </li>
            </ul>
            <p className="small">
              Depending on the state where your business is located and other
              attributes of your business and the loan, your business loan may
              be issued by a member of the OnDeck family of companies or by
              Celtic Bank. Your loan agreement will identify the lender prior to
              your signing. Loans subject to lender approval.
            </p>
            <p className="small">
              OnDeck&reg; is a Registered Trademark. All rights reserved.
            </p>
            <p className="small">
              4700 W. Daybreak Pkwy., Suite 200, South Jordan, UT 84009
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default CheckoutFooter;
